import { useState } from 'react';
import styled from 'styled-components';
import WidgetIdWrapper from '../shared/WidgetIdWrapper';
import { withWidgetSpacingWrapper } from '../shared/WidgetSpacingWrapper';
import BioCard from './cards/BioCard';
import { device } from '../../utils/styled-component-mixins';
import useMediaQuery from '../custom-hooks/useMediaQuery';
import { useLocalization } from '../custom-hooks/useLocalization';
import { withLocalization } from '../shared/Context/LocalizationContext';
import { compose } from '../utils/compose';

const KeyContactsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  @media ${device.desktop} {
    padding: 0 20rem;
  }

  h2 {
    margin-bottom: 0;
    text-align: center;
  }

  .bio-card-summary {
    margin-bottom: 6.4rem;

    > * {
      font-size: 1.8rem;
      line-height: 2.4rem;
      text-align: center;

      @media ${device.desktop} {
        font-size: 2rem;
        line-height: 3.2rem;
      }
    }
  }

  button {
    margin-top: 2rem;
  }
`;

const KeyContactsList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;

  li {
    &::before {
      content: none;
    }
  }

  @media ${device.desktop} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    column-gap: 5rem;
  }

  li {
    @media ${device.desktop} {
      flex-basis: calc(25% - 3.75rem);
    }
  }
`;

const KeyContacts = (props) => {
  const { properties, items } = props;
  const { resourceStrings } = useLocalization();
  const loadMoreText = resourceStrings['bdO.KeyContactsWidget.LoadMore'];
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const isDesktop = useMediaQuery(device.desktop);
  // eslint-disable-next-line no-nested-ternary
  const itemsToShow = isButtonClicked ? items.length : isDesktop ? 8 : 2;
  const hasMoreItems = items.length > itemsToShow;
  const viewBioText = resourceStrings['bdO.KeyContactsWidget.ViewBio'];

  return (
    <WidgetIdWrapper widgetID={properties.widgetID}>
      <KeyContactsWrapper>
        <h2>{properties.heading}</h2>
        <div
          className="bio-card-summary"
          dangerouslySetInnerHTML={{ __html: properties.description }}
        />
        <KeyContactsList className="non-bdo-style-list">
          {items.slice(0, itemsToShow).map((item, index) => (
            <BioCard key={index} {...item} viewBioText={viewBioText} />
          ))}
        </KeyContactsList>

        {hasMoreItems && !isButtonClicked && (
          <button className="btn btn-secondary" onClick={() => setIsButtonClicked(true)}>
            {loadMoreText}
          </button>
        )}
      </KeyContactsWrapper>
    </WidgetIdWrapper>
  );
};

export default compose(withLocalization, withWidgetSpacingWrapper)(KeyContacts);
